import {aesUtil} from "@/utils/aesUtil";

/**
 * @description 存储sessionStorage
 */
export const setStore = (name, value) => {
    if (!name) return;
    if (typeof value === "object") {
        value = JSON.stringify(value);
    }
    window.sessionStorage.setItem(name, aesUtil._encryptText(value));
};

/**
 * @description 读取sessionStorage
 * @param {string} name
 */
export const getStore = name => {
    if (!name) return;
    if (window.sessionStorage.getItem(name)) {
        const data = aesUtil._decryptText(window.sessionStorage.getItem(name))
        try {
            return JSON.parse(data)
        } catch (e) {
            return data
        }
    }
    return ''
};

/**
 * @description 删除sessionStorage
 * @param {需要删除的keyName} name
 */
export const removeStore = name => {
    if (!name) return;
    window.sessionStorage.removeItem(name);
};

/**
 * 删除所有
 */
export const removeStoreAll = () => {
    window.sessionStorage.clear();
};
